export default __webpack_public_path__ + "static/media/B45D&B40D.18f457db.pdf";